<mat-card [class]="'p-0 mb-10 fx-flex-100 clickable ' + class" *ngIf="case" [routerLink]="'/cases/'+case._id">
  <div class="fx-row fx-wrap  align-items-center justify-content-between p-16">
    <div class="fx-row align-items-center justify-content-between fx-flex-100">
      <span class="text bold">{{case.identifier || case.reference}}</span>
      <div class="chip" [class.red]="case.state == 'CLOSED'" [class.green]="case.state == 'OPENED'" *ngIf="showState">
        {{'CASE.PHASE_'+case.state | translate}}</div>
    </div>

    <span class="small main" *ngIf="case.state !== 'CLOSED' && !case.timePeriod.end">{{'CASE.PHASE_ENDS_MANUAL' |
      translate}}</span>
  </div>
  <mat-divider></mat-divider>
  <div class="fx-row align-items-center justify-content-start p-16">
    <div class="fx-column fx-flex-50">
      <span class="small light">{{'ENTITIES.TRADEMARK' | translate}}</span>
      <span class="text">{{case.trademark.name || case.trademark.identifierNumber}}</span>
      <span class="small">{{case.trademark.countryOfDesignation}} - {{case.trademark.identifierNumber}}</span>
    </div>
    <div class="fx-column fx-flex-50" *ngIf="case">
      <app-trademark-nice-classification [niceClassification]="case.niceClassification"
        class="mt-5"></app-trademark-nice-classification>
    </div>
  </div>
  <div class="fx-row align-items-center justify-content-start p-16">
    <div class="fx-column fx-flex-100 mt-5">
      <span class="small light">{{'CASE.PERIOD' | translate}}</span>
      <span class="text">{{formatDate(case.timePeriod.start)}} - {{formatDate(case.timePeriod.end)}}</span>
    </div>
    <div class="fx-column fx-flex-100 mt-5">
      <span class="small light">{{'CASE.TYPE' | translate}}</span>
      <span class="text">{{'CASE.TYPE_'+case.type | translate}}</span>
    </div>
  </div>

  <div class="main-bg p-16" *ngIf="case.type != 'RENEWAL_MAINTENANCE'">
    <app-case-score [score]="case.score || {global:0}" [style]="'condensed'" [color]="color"></app-case-score>
  </div>
  <div class="fx-row align-items-center justify-content-start mt-10" *ngIf="case.state === 'CLOSED' && closedMeta">
    <div class="bullet" [class.green]="closedMeta['decision'] === 'WON'"
      [class.orange]="closedMeta['decision'] === 'MITIGATED'" [class.red]="closedMeta['decision'] === 'LOST'"
      *ngIf="!closedMeta['withdrawal']" [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'CASE.CLOSED_'+closedMeta['decision'] |
        translate">
    </div>
    <div class="fx-row align-items-center justify-content-start ml-10" *ngIf="!closedMeta['withdrawal']">
      <mat-icon class="mr-5" [class.green]="closedMeta['definitive']" [class.orange]="!closedMeta['definitive']"
        fontSet="material-icons-outlined" [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="(closedMeta['definitive'] ? 'CASE.DEFINITIVE' : 'CASE.NOT_DEFINITIVE') |
            translate">{{closedMeta['definitive'] ? 'check_circle' :
        'error_outline'}}</mat-icon>
      <span class="text">{{(closedMeta['definitive'] ? 'CASE.DEFINITIVE' :
        'CASE.NOT_DEFINITIVE')
        |
        translate}}</span>
    </div>
  </div>
</mat-card>